import { get } from 'utils';

export default function getGlobalServiceWindow(
  onSuccess = () => {},
  onError = () => {},
  onFinally = () => {}
) {
  get({ apiKey: 'configure.serviceWindow.global' })
    .then(({ data }) => onSuccess(data))
    .catch(onError)
    .finally(onFinally);
}
